import { render, staticRenderFns } from "./RefertazioneEcocardioEdit.vue?vue&type=template&id=92100ef4&scoped=true"
import script from "./RefertazioneEcocardioEdit.vue?vue&type=script&lang=js"
export * from "./RefertazioneEcocardioEdit.vue?vue&type=script&lang=js"
import style0 from "./RefertazioneEcocardioEdit.vue?vue&type=style&index=0&id=92100ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92100ef4",
  null
  
)

export default component.exports